import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const CustomNotificationBadge = ({ count, style = {}, isDark = false }) => {
  const [show, setShow] = useState(count > 0)

  useEffect(() => {
    setShow(count > 0)
  }, [count])

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0 }}
          transition={{ duration: 0.3 }}
          style={{
            position: 'absolute',
            backgroundColor: isDark ? '#fff' : '#272626',
            color: isDark ? '#000' : '#fff',
            borderRadius: '50%',
            fontSize: '12px',
            minWidth: '20px',
            maxHeight: '18px',
            textAlign: 'center',
            ...style
          }}
        >
          {count}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default CustomNotificationBadge
